import { Cartesian2, Cartesian3 } from "cesium";
import { EarthBrainUtils } from "./earthbrainutility";
export var LineWorkUtils;
(function (LineWorkUtils) {
    function traceLineWorksOnPointCloud(pathPoints, stepBetweenTwoPoints) {
        const lineWorksOutlineCartesians = [];
        for (let j = 0; j < pathPoints.length - 1; j++) {
            const startPoint = pathPoints[j];
            const endPoint = pathPoints[j + 1];
            const isLastPoint = j + 1 === pathPoints.length - 1;
            const points = tracePointCloudBetweenTwoPoints(startPoint, endPoint, stepBetweenTwoPoints, true, isLastPoint);
            if (lineWorksOutlineCartesians[lineWorksOutlineCartesians.length - 1] &&
                points[0]) {
                if (Cartesian3.equals(lineWorksOutlineCartesians[lineWorksOutlineCartesians.length - 1]
                    .controlPoint, points[0])) {
                    lineWorksOutlineCartesians.pop();
                }
            }
            lineWorksOutlineCartesians.push(...points.map((p) => ({
                controlPoint: p,
                controlPointOnEllipsoid: new Cartesian3(p.x, p.y, 0),
            })));
        }
        return lineWorksOutlineCartesians;
    }
    LineWorkUtils.traceLineWorksOnPointCloud = traceLineWorksOnPointCloud;
    function tracePointCloudBetweenTwoPoints(startPoint, endPoint, step, includeStart, includeEnd) {
        const result = [];
        if (Cartesian3.equals(startPoint, endPoint)) {
            console.warn(`Start and End point for are same. Please check the data for LineWorks.`);
        }
        else {
            const dir = EarthBrainUtils.getNormalizedDirection(startPoint, endPoint);
            const distBetweenPoint = Cartesian3.distance(startPoint, endPoint);
            const count = Math.floor(distBetweenPoint / step);
            let i = 0;
            includeStart && result.push(startPoint);
            while (i < count) {
                const pointAtStep = new Cartesian3();
                Cartesian3.multiplyByScalar(dir, i * step, pointAtStep);
                Cartesian3.add(pointAtStep, startPoint, pointAtStep);
                result.push(pointAtStep);
                i++;
            }
            includeEnd && result.push(endPoint);
        }
        return result;
    }
    LineWorkUtils.tracePointCloudBetweenTwoPoints = tracePointCloudBetweenTwoPoints;
    function createTilesetOutlineOfLineWorks(pathArray, tileset) {
        const outline = [];
        let xDistFromStart = 0;
        for (let i = 0; i < pathArray.length; ++i) {
            if (pathArray[i - 1]) {
                xDistFromStart += Cartesian3.distance(pathArray[i - 1].controlPointOnEllipsoid, pathArray[i].controlPointOnEllipsoid);
            }
            const projectHeight = tileset.getProjectPointHeight(pathArray[i].controlPoint);
            if (projectHeight) {
                outline.push([xDistFromStart, projectHeight]);
            }
        }
        return outline;
    }
    LineWorkUtils.createTilesetOutlineOfLineWorks = createTilesetOutlineOfLineWorks;
    function createOutlineForLineWorks(pointsLocal) {
        const outline = [];
        let dist = 0;
        for (let i = 0; i < pointsLocal.length; ++i) {
            if (pointsLocal[i - 1]) {
                dist += Cartesian2.distance(pointsLocal[i - 1], pointsLocal[i]);
            }
            if (pointsLocal[i] !== undefined) {
                const height = pointsLocal[i].z;
                outline.push([dist, height]);
            }
        }
        return outline;
    }
    LineWorkUtils.createOutlineForLineWorks = createOutlineForLineWorks;
})(LineWorkUtils || (LineWorkUtils = {}));
//# sourceMappingURL=line-work-utils.js.map